function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var genDictArrayCascaderStyles = function genDictArrayCascaderStyles(prefixCls, token) {
  return [_defineProperty({}, ".".concat(prefixCls), {
    width: '100%',
    '&.readOnly': _defineProperty({
      '.ant-select-selection-overflow': {
        maxHeight: '49px',
        overflow: 'hidden',
        overflowY: 'scroll'
      },
      '.ant-select-selector,.ant-select-selection-item,.ant-select-selector input': {
        background: 'transparent',
        border: 'none',
        cursor: 'auto',
        color: 'rgba(0, 0, 0, 0.88)',
        margin: '0',
        padding: '0'
      },
      '.ant-select-selection-item-content': _defineProperty({}, "&::after", {
        content: "','",
        display: 'block',
        position: 'absolute',
        bottom: 0,
        right: 0,
        height: '24px',
        lineHeight: '22px'
      }),
      '.ant-select-arrow': {
        display: 'none'
      }
    }, '.ant-select-selection-overflow-item:last-child,.ant-select-selection-overflow-item:nth-last-child(2)', _defineProperty({}, ".ant-select-selection-item-content::after", {
      content: "''"
    }))
  })];
};